
  import tippy from 'tippy.js'
  import { findAncestorWithClass } from '../utils/find-ancestor'


  export default {
  /* tslint:disable */
  render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],ref:"popup",staticClass:"ae-popup",style:(_vm.style)},[_vm._t("default",null,{"close":_vm.close,"position":_vm.position,"data":_vm.data}),_vm._v(" "),(_vm.visible)?_vm._t("popup",null,{"close":_vm.close,"position":_vm.position,"data":_vm.data}):_vm._e()],2)},
  staticRenderFns: [],
  /* tslint:enable */
  
    data: () => ({
      visible: false,
      data: null,
      style: {},
    }),
    props: {
      target: {
      },
      placement: {
        type: String,
        default: 'auto'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      trigger: {
        type: String,
        default: 'manual' // Or 'mouseenter focus click' or 'mouseenter'
      },
      delay: {
        type: Array,
        default: () => [100, 10]
      },
      hideOnClick: {
        default: 'toggle' // Or 'true' or 'false'
      },
      touch: {
        default: undefined
      },
      onClose: {
        type: Function,
        default: null
      },
      closeDelay: {
        type: Number,
        default: 0
      },
      interactiveBorder: {
        type: Number,
        default: 50,
      },
      clickable: {
        type: Boolean,
        default: true,
      },
      maxWidth: {
        type: [String, Number],
        default: 350,
      },
      arrow: {
        default: true,
      },
      theme: {
        type: String,
        default: 'ae-tippy-theme',
      },
    },
    methods: {
      toggle(event: Event, data: any) {
        if (this.visible) {
          this.close()
        } else {
          this.show(event, data)
        }
      },
      close() {
        if (this.closeDelay) {
          this._closeTimeout = setTimeout(() => {
              this.closeImmediately()
          }, this.closeDelay)
        } else {
          this.closeImmediately()
        }
      },
      open(...args) {
        console.warn('deprecated: Use show instead')
        this.show(...args)
      },
      hide() {
        this.close()
      },
      show(event: Event, data: any) {
        if (this.disabled) {
          return
        }

        if (!event) {
          console.error('Provide a target to AePopup.show')
          return
        }

        const target= this.target ?? event.target

        this.data = data
        this._show(target)
      },
      showAtPosition(event: MouseEvent = null, data: any) {
        console.warn('deprecated: use show instead of showAtPosition')

        this.show(event, data)
      },
      cancelClose() {
        if (this._closeTimeout) {
          clearTimeout(this._closeTimeout)
          this._closeTimeout = null
        }
      },
      position() {
        if (this._tippy?.popperInstance) {
          this._tippy.popperInstance.update()
        }
      },
    },
    created() {
      this._closeTimeout = null

      this._create = (target: HTMLElement|string) => {
        if (this._tippy) {
          return
        }
        
       if (typeof target === 'string') {
          if (target.startsWith('ae_i')) {
            target = `#${target}` // Assume it's an ID selector
          }

          target = document.querySelector(target) as HTMLElement
        }

        if (!target || !this.$refs.popup) {
          return
        }
        
        this._tippy = tippy(target, {
          content: this.$refs.popup,
          theme: this.theme,
          interactive: this.clickable,
          delay: this.delay,
          trigger: this.trigger,
          maxWidth: this.maxWidth === '' ? null : this.maxWidth,
          interactiveBorder: this.interactiveBorder,
          arrow: this.arrow,
          placement: this.placement,
          touch: this.touch,
          hideOnClick: this.hideOnClick,
          appendTo: () => 
              this.$refs.popup.ownerDocument.querySelector('.ae-dialog-region') || this.$refs.popup.ownerDocument.querySelector('.ae-root') || this.$refs.popup.ownerDocument,
          onShow: () => {
            this.visible = true
          },
          onShown: () => {
            this.position()

            this.$emit('show')
          },
          onHidden: () => {
            this.$emit('hide')
            this.visible = false
          },
          onClickOutside: (instance, event) => {
            // This prevents closing the parent popup when nesting popups (because they are not actually nested, but siblings)
            if (findAncestorWithClass(event.target, 'ae-popup')) {
              return
            }

            this.close()
          },
          onTrigger(instance,event) {
            console.log('onTrigger', instance, event)
          }
        })

        if (!this._tippy) {
          console.error('Failed to create tippy instance')
          return
        }

        if (!this._tippy.destroy) {
          console.error('Tippy instance does not have destroy method')
          return
        }
      }

      this._show = async (target) => {
        this._create(target)
        this.cancelClose()

        this.visible = true

        this._tippy.show()
      }
        
      this.closeImmediately = () => {
        this.cancelClose()

        this.visible = false
        this._baseNode = null

        this.$nextTick(() => {
          this.unregister()

          this.$emit('close')
        })
      }

      this.unregister = () => {
        if (this._tippy) {
          this._tippy.destroy()
          this._tippy = null
        }
      }
    },
    mounted() {
      if (this.target) {
        this._create(this.target)
      }

      this._resizeObserver = new ResizeObserver(() => {
        if (this.visible) {
          this.position()
        }
      })
      this._resizeObserver.observe(this.$refs.popup)
    },
    watch: {
      target: {
        handler(newTarget) {
          if (newTarget) {
            this._tippy?.destroy()
            this._tippy = null

            this._create?.(newTarget)
          }
        }
      },
      disabled() {
        if (this.disabled) {
          this.closeImmediately()
        }
      }
    },
    beforeDestroy() {
      this._resizeObserver?.disconnect()
      this.closeImmediately()
      this.unregister()
    }
  }
